import { Divider, Drawer, Typography } from "@mui/material";
import * as React from "react";
import { useRecoilState } from "recoil";
import { USE_ACTION_DRAWER } from "../../../hooks/useActionDrawer";

import CartList from "./actions/CartList";
import WishList from "./actions/WishList";
import Auth from "./actions/Auth";
import Menu from "./actions/Menu";

const ActionsDrawer: React.FC = () => {
  const [drawer, setDrawer] = useRecoilState(USE_ACTION_DRAWER);

  return (
    <Drawer
      variant="temporary"
      container={document.getElementById("XPage")}
      anchor={drawer === "MENU" ? "left" : "right"}
      open={drawer !== null}
      onClose={() => {
        setDrawer(null);
      }}
      PaperProps={{
        sx: { width: 300 },
      }}
    >
      <Typography
        variant="h4"
        component="p"
        px={2}
        lineHeight="64px"
        fontWeight={800}
        fontSize={24}
      >
        {drawer === "CART" && "Mon Panier"}

        {drawer === "WISHLIST" && "Mes Favoris"}

        {drawer === "ACCOUNT" && "Mon Compte"}

        {drawer === "MENU" && "Menu"}
      </Typography>

      <Divider />

      {drawer === "MENU" && <Menu />}

      {drawer === "CART" && <CartList />}

      {drawer === "WISHLIST" && <WishList />}

      {drawer === "ACCOUNT" && <Auth />}
    </Drawer>
  );
};

export default ActionsDrawer;
